<template>
  <div class="container">
    <div class="row g-3 g-md-5">
      <div class="col-12">
        <div class="alert alert-warning alert-dismissible fade show mt-3" role="alert">
          <strong>抢先预览!</strong> 内容整理中，有任何意见请在群内反馈。
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <h1 class="pt-5">💪 用户体验挑战</h1>
        <h5 class="fw-normal text-black-50">UX challenges</h5>
        <p>在设定的虚拟场景中，充分利用精选的教程和辅助工具完成你的 UX 挑战，发现更卷的自己 :) </p>
        <div>
          <a href="" class="btn me-2 bg-color1 badge rounded-pill text-light"><svg-icon icon-class="circle-check" /> 理解</a>
          <a href="" class="btn me-2 bg-color2 badge rounded-pill text-light"><svg-icon icon-class="circle-check" />概念</a>
          <a href="" class="btn me-2 bg-color3 badge rounded-pill text-light"><svg-icon icon-class="circle-check" />测试</a>
          <a href="" class="btn me-2 bg-color4 badge rounded-pill text-light label-uncheck"><svg-icon icon-class="circle" />实施</a>
        </div>
      </div>
      <div class="col-6 col-md-3 col-xl-2 cards" v-for="item in data.cards" :key="item.id">
        <router-link :to="'/page/'+item.id"><svg-icon :icon-class="item.sidea" /></router-link>
        <h5 class="mt-2 text-center">{{item.name}}<div class="ms-2 badge text-secondary text-bg-light">{{item.cate}}</div></h5>
      </div>
    </div>
    <contrib />
    <div class="row justify-content-center mt-5">
      <div class="col-sm-12 col-md-8">
        <a href="https://aicc.pro?refer=uxlib.net" target="_blank"><img src="https://aicdn.uxlib.cn/wp-content/uploads/2023/11/20231129223608161.png" alt="加入AI 知识共创: https://aicc.pro" style="max-width: 100%;height: auto;" /></a>
      </div>
    </div>
    
  </div>
</template>

<script>
import data from '../data/data-cn.json'

import Contrib from '../components/Contrib.vue'

export default {
  name: 'Page',
  data () {
    return {
      data
    }
  },
  components: {
    Contrib
  }
}
</script>
<style lang="scss" scoped>

.bg-color1 { background-color: darken(#c494d6, 25) !important; border-color: darken(#c494d6, 25) !important; }
.bg-color2 { background-color: darken(#efd074, 25) !important; border-color: darken(#efd074, 25) !important; }
.bg-color3 { background-color: darken(#f5907c, 25) !important; border-color: darken(#f5907c, 25) !important; }
.bg-color4 { background-color: darken(#67cfbc, 25) !important; border-color: darken(#67cfbc, 25) !important; }
.label-uncheck { background-color: #fff !important; color: lighten(#000000, 35) !important;
& svg{
  opacity: .2;
}
}

.cards svg {
  width: 9rem;
  height: 12rem;
}
.badge svg{
  width: 1rem;
  height: 1rem;
  vertical-align: -3px;
  margin-right: .2rem;
}
</style>
